import React from "react";
import StaticPostLayout from "../components/StaticPostLayout";
import MapShenandoahNationalPark from "../components/Maps/shenandoah-national-park";
import ShenandoahNationalParkInfo from "../components/TripInfo/shenandoah-national-park";

class ShenandoahNationalPark extends React.Component {
  render() {
    return (
      <StaticPostLayout
        title="Shenandoah National Park: 3-Day Skyline Drive Itinerary"
        category="National Parks"
        slug="shenandoah-national-park-itinerary"
        excerpt="The Blue Ridge Mountains 75 miles from DC — Skyline Drive overlooks, Old Rag's legendary rock scramble, waterfalls, and Appalachian Trail access all in one compact park."
        tags={["National Parks", "Hiking", "East Coast", "Virginia", "Road Trips", "Fall Foliage"]}
        readTime="7 min read"
        mapComponent={<MapShenandoahNationalPark />}
        whereToStay={[
          { name: 'Hotels in Luray', type: 'North Entrance · Luray, VA', url: 'https://www.booking.com/searchresults.html?ss=Luray%2C+Virginia' },
          { name: 'Big Meadows Lodge', type: 'NPS Lodge · Milepost 51 on Skyline Drive', url: 'https://www.booking.com/searchresults.html?ss=Shenandoah+National+Park%2C+Virginia' },
          { name: 'Hotels in Front Royal', type: 'North Gateway · Front Royal, VA', url: 'https://www.booking.com/searchresults.html?ss=Front+Royal%2C+Virginia' },
        ]}
      >
        <ShenandoahNationalParkInfo />
      </StaticPostLayout>
    );
  }
}

export default ShenandoahNationalPark;
